// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"5527a1de","956":"8a58e3b7"}[chunkId] + ".css";
};